export default __webpack_public_path__ + "img/bg_social_media-c6e40efc2d0f738f716dba7400de40c2.jpeg";